import React, { Component } from "react";
import Form from "./Form";
import { apiUrl } from "../../../utils/apiUrl";
import { toast } from "../../../utils/helpers";
import { postRequest } from "../../../utils/request";
import { etiquetaCategoria } from "../../../utils/categorias";

class Create extends Component {
    state = {
        errors: {},
        grupo: {}
    };
    createGrupo = async event => {
        event.preventDefault();
        // El popup se abre desde CategoriasCheckboxTree, dentro del <form> del
        // producto: sin esto el submit burbujea y también dispara el submit
        // del formulario de producto con el FormData de esta categoría.
        event.stopPropagation();

        const data = new FormData(event.target);

        const response = await postRequest(apiUrl("grupos"), data);



        if (response.success) {
            // Se espera la recarga para que quien escuche `onCreado` ya tenga la
            // categoría nueva en el árbol.
            await this.props.getGrupos();
            this.props.onCreado?.(response.data);
            this.props.toggle();
        }
        if (response.code === 422) {
            // Los errores de jerarquía llegan como un mensaje suelto, no por campo.
            if (typeof response.data?.message === "string") {
                this.setState({ errors: {} });
                toast(response.data.message, "error");
                return;
            }

            this.setState({ errors: response.data.message });
        }
    };
    render() {
        const { errors, grupo } = this.state;
        const { toggle, padre, arbol } = this.props;
        return (
            <form method='post' onSubmit={this.createGrupo}>
                <div className='popup__header'>
                    {padre
                        ? `Nueva subcategoría de ${etiquetaCategoria(padre)}`
                        : "Nuevo Grupo"}
                </div>
                <div className='popup__body'>
                    <Form
                        grupo={grupo}
                        errors={errors}
                        arbol={arbol}
                        padre={padre}
                    />
                </div>
                <div className='popup__footer'>
                    <button
                        type='button'
                        onClick={toggle}
                        className='btn btn-plain'>
                        Cancelar
                    </button>
                    <button type='submit' className='btn btn-primary'>
                        Crear
                    </button>
                </div>
            </form>
        );
    }
}

export default Create;
